import React from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'

const TechnologyBoard = ({
  boardHeading,
  boardMemberName1,
  boardMemberTitle1,
  boardMemberDescription1,
  boardMemberImage1,
  boardMemberName2,
  boardMemberTitle2,
  boardMemberDescription2,
  boardMemberImage2,
}) => {
  return (
    <StyledBoard>
      <Heading>{boardHeading}</Heading>
      <Members>
        <Member>
          <GatsbyImage fluid={boardMemberImage1.fluid} />
          <MemberName>{boardMemberName1}</MemberName>
          <MemberDescirption>{boardMemberTitle1}</MemberDescirption>
          <MemberQuote>
            {boardMemberDescription1.boardMemberDescription1}
          </MemberQuote>
        </Member>
        <Member>
          <GatsbyImage fluid={boardMemberImage2.fluid} />
          <MemberName>{boardMemberName2}</MemberName>
          <MemberDescirption>{boardMemberTitle2}</MemberDescirption>
          <MemberQuote>
            {boardMemberDescription2.boardMemberDescription2}
          </MemberQuote>
        </Member>
      </Members>
    </StyledBoard>
  )
}

const StyledBoard = styled.section`
  padding: ${(props) => props.theme.space.marginMobile * 6}vw 0;
  overflow: hidden;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: ${(props) => props.theme.space.marginDesktop * 14}vw
      ${(props) => props.theme.space.marginDesktop * 16}vw
      ${(props) => props.theme.space.marginDesktop * 10}vw;
  }
`

const Heading = styled.h2`
  font-size: 6vw;
  text-align: center;
  padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d35};
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 2}vw;
  }
`

const Members = styled.ul`
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    overflow: hidden;
    flex-wrap: wrap;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

const Member = styled.li`
  min-width: 50vw;
  margin-right: 15vw;
  white-space: nowrap;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    min-width: auto;
    margin-right: auto;
    width: calc(50% - ${(props) => props.theme.space.marginDesktop * 8}vw);
    padding: ${(props) => props.theme.space.marginDesktop * 4}vw;
  }

  &:first-child {
    padding-left: 25vw;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      padding-left: ${(props) => props.theme.space.marginDesktop * 4}vw;
    }
  }

  &:last-child {
    padding-right: 25vw;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      padding-right: ${(props) => props.theme.space.marginDesktop * 4}vw;
    }
  }
`

const MemberName = styled.h3`
  font-size: ${(props) => props.theme.fontSize.m35};
  text-align: center;
  padding: ${(props) => props.theme.space.marginMobile * 2}vw 0
    ${(props) => props.theme.space.marginMobile}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d25};
    padding: ${(props) => props.theme.space.marginDesktop * 2}vw 0
      ${(props) => props.theme.space.marginDesktop}vw;
  }
`

const MemberQuote = styled.p`
  font-size: ${(props) => props.theme.fontSize.m26};
  text-align: center;
  font-style: italic;
  padding-top: ${(props) => props.theme.space.marginMobile}vw;
  white-space: normal;
  line-height: 1.2;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d14};
    padding-top: ${(props) => props.theme.space.marginDesktop}vw;
  }
`

const MemberDescirption = styled.div`
  font-size: ${(props) => props.theme.fontSize.m20};
  text-align: center;
  padding: 0;
  white-space: normal;
  line-height: 1.5;
  min-height: 3em;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d14};
    padding: 0 0 ${(props) => props.theme.space.marginDesktop}vw;
    min-height: 0;
  }
`

export default TechnologyBoard
